{
  "language.label": "Taal",
  "language.english": "Engels",
  "language.english.full": "Engels (English)",
  "language.french": "Frans",
  "language.french.full": "Frans (Français)",
  "language.dutch": "Nederlands",
  "language.dutch.full": "Nederlands (Nederlands)",
  "logo.alt": "Flourish-logo",
  "brand.tagline": "Champagne-regio",
  "brand.taglineFooter": "Champagne-regio",
  "nav.tourism": "Toerisme",
  "nav.route": "Toeristische route",
  "nav.community": "Community",
  "nav.wineries": "Champagnehuizen",
  "nav.download": "Download",
  "nav.partner": "Word partner",
  "nav.downloadCta": "Download de app",
  "partnerModal.eyebrow": "Partnerregistratie",
  "partnerModal.title": "Ben je een champagnehuis?",
  "partnerModal.body": "Dit portaal is alleen voor champagnehuizen die zich willen registreren en in Flourish verschijnen. Bevestig voordat je doorgaat.",
  "partnerModal.confirm": "Ja, ga naar registratie",
  "partnerModal.cancel": "Nee, ik wil ontdekken",
  "partnerModal.close": "Sluit venster",
  "hero.eyebrow": "De perfecte app om champagne te ontdekken",
  "hero.title": "Ontdek de Champagestreek met Flourish.",
  "hero.body": "Flourish is je elegante reisgenoot terwijl je door de Champagne trekt. Volg de Route Touristique, ontdek nieuwe plekken en maak van elke stop een levendig verhaal met lokale reviews en ervaringen van vrienden.",
  "hero.highlight.reviews.title": "Reviews per locatie",
  "hero.highlight.reviews.body": "Proefnotities, sfeer en insider-tips bij elke stop.",
  "hero.highlight.friends.title": "Volg je vrienden",
  "hero.highlight.friends.body": "Bekijk hun routes, favorieten en de reviews die ze deelden.",
  "hero.appStoreAlt": "Download in de App Store",
  "hero.playStoreAlt": "Ontdek op Google Play",
  "home.dashboard.hero.eyebrow": "Flourish op het web",
  "home.dashboard.hero.title": "Plan, ontdek en beleef Champagne.",
  "home.dashboard.hero.body": "Verken champagnehuizen en hun wijnselectie, ontdek bezienswaardigheden zoals musea, historische locaties, uitzichtpunten en attracties, en volg de officiële Route Touristique-lussen om je volgende bezoek op één plek te plannen.",
  "home.dashboard.hero.primaryCta": "Open de webkaart",
  "home.dashboard.hero.secondaryCta": "Download de mobiele app",
  "home.dashboard.hero.loginCta": "Log in om te synchroniseren",
  "home.dashboard.hero.stepsTitle": "De 3 voordelen van het platform",
  "home.dashboard.hero.steps.one.title": "Ontdek de champagnehuizen",
  "home.dashboard.hero.steps.one.body": "Leer hun geschiedenis, hoe ze champagne maken en hun signatuurcuvées.",
  "home.dashboard.hero.steps.two.title": "Een breed aanbod locaties",
  "home.dashboard.hero.steps.two.body": "Musea, uitzichtpunten, bezienswaardigheden en meer.",
  "home.dashboard.hero.steps.three.title": "Lees ervaringen",
  "home.dashboard.hero.steps.three.body": "Ontdek wat andere bezoekers vonden.",
  "home.dashboard.overview.eyebrow": "In één oogopslag",
  "home.dashboard.overview.title": "Jouw Champagne-dashboard",
  "home.dashboard.stats.comingSoon": "Binnenkort beschikbaar",
  "home.dashboard.stats.loginRequired": "Log in om te synchroniseren",
  "home.dashboard.explore.eyebrow": "Ontdek nu",
  "home.dashboard.explore.title": "Selectie van dit moment in Champagne",
  "home.dashboard.explore.body": "Een wisselende mix van champagnehuizen en bezienswaardigheden voor je volgende stop.",
  "home.dashboard.explore.openMap": "Ontdek meer plekken",
  "home.dashboard.explore.empty": "We stellen deze selectie samen. Kom binnenkort terug.",
  "home.dashboard.routes.title": "Toeristische routes",
  "home.dashboard.routes.body": "Zes officiële Route Touristique-lussen zijn beschikbaar op de webkaart.",
  "home.dashboard.activity.title": "Community-activiteit",
  "home.dashboard.activity.body": "Bekijk de laatste proeverijen en bezoeken uit je netwerk.",
  "home.dashboard.activity.empty": "Nog geen recente activiteit om te tonen.",
  "home.dashboard.activity.more": "Open activiteit",
  "home.dashboard.activity.loginTitle": "Log in om activiteit te bekijken",
  "home.dashboard.activity.loginBody": "Meld je aan om proeverijen en bezoeken van jou en je vrienden te zien.",
  "home.dashboard.activity.loginCta": "Ga naar inloggen",
  "home.dashboard.mobile.eyebrow": "Mobiele companion",
  "home.dashboard.mobile.title": "Neem Flourish mee onderweg",
  "home.dashboard.mobile.body": "Gebruik web om te plannen en ga verder in de app tijdens je reis door Champagne.",
  "route.eyebrow": "Route touristique",
  "route.title": "Plan een dag op maat, zonder drukte.",
  "route.body": "Flourish verbindt dorpen, uitzichtpunten en proeverijen tot één vloeiende route. Volg de klassieke route of stel een eigen route op langs je favorite plaatsen.",
  "route.cards.one.title": "Begin met een signatuurroute",
  "route.cards.one.body": "Kies een kant-en-klare Route Touristique of maak je eigen planning aan de hand van je favoriete locaties.",
  "route.cards.two.title": "Ontdek verborgen parels",
  "route.cards.two.body": "Ontdek nieuwe uitzichtpunten, attracties en lokale adresjes.",
  "route.cards.three.title": "Maak het sociaal",
  "route.cards.three.body": "Nodig vrienden uit, vergelijk notities en bewaar elkaars favoriete stops.",
  "community.eyebrow": "Community reviews",
  "community.title": "Elke stop heeft een verhaal.",
  "community.body": "Reviews tonen je wat je er kunt verwachten. Volg je vrienden om hun favoriete plekken en aanbevelingen te ontdekken.",
  "community.reviews.one.name": "Camille R.",
  "community.reviews.one.body": "\"Net voor zonsondergang aangekomen. Intieme proefruimte en een onvergetelijke roséflight.\"",
  "community.reviews.one.location": "Verzenay - Grand Cru stop",
  "community.reviews.two.name": "Lucas M.",
  "community.reviews.two.body": "\"De kelderrondleiding zat vol detail. Geweldig om de pairing-notes van locals te lezen.\"",
  "community.reviews.two.location": "Hautvillers - Erfgoedroute",
  "community.reviews.three.name": "Jules + Nora",
  "community.reviews.three.body": "\"We volgden de route van vrienden, voegden een picknick toe en eindigden met een gouden toast.\"",
  "community.reviews.three.location": "Cote des Blancs",
  "wineries.tag": "Binnenkort beschikbaar",
  "wineries.title": "Ontdek uitzonderlijke champagnehuizen",
  "wineries.body": "Wij selecteren zorgvuldig champagnehuizen met proeverijen en unieke wijnen voor jullie.",
  "wineries.cards.one.title": "Contacteer het wijnhuis",
  "wineries.cards.one.body": "Neem rechtstreeks contact op om te informeren naar bezoeken, beschikbaarheid en ervaringen.",
  "wineries.cards.two.title": "Huis-signatures",
  "wineries.cards.two.body": "Ontdek uitzonderlijke cuvées en het verhaal achter elke kelder.",
  "wineries.cards.three.title": "Verzamelaarselecties",
  "wineries.cards.three.body": "Houd je favoriete flessen bij in de app en deel je ervaringen met vrienden.",
  "download.eyebrow": "Nu beschikbaar",
  "download.title": "Download Flourish en start je Champagnetour.",
  "download.body": "Vind de app in de App Store of Google Play en verzamel routes, reviews en aanbevelingen.",
  "download.qrLabel": "Scan om de app te downloaden.",
  "download.qrAlt": "QR-code om de Flourish-app te downloaden",
  "download.modal.close": "Dialoog sluiten",
  "appPromo.eyebrow": "Geoptimaliseerde mobiele app",
  "appPromo.title": "Download de Flourish-app",
  "appPromo.body": "Deze ervaring hoort in de app. Download hem om de kaart te verkennen, favorieten te bewaren en activiteit te volgen.",
  "appPromo.homeLink": "Ga verder naar de website",
  "web.nav.home": "Home",
  "web.nav.map": "Kaart",
  "web.nav.houses": "Champagnehuizen",
  "web.nav.experiences": "Ervaringen",
  "web.nav.guides": "Gidsen",
  "web.map.locate": "Focus op mijn locatie",
  "web.map.eyebrow": "Interactieve kaart",
  "web.map.title": "Ontdek Champagne op het web",
  "web.map.subtitle": "Verken champagnehuizen, bezienswaardigheden en toeristische routes op een desktopvriendelijke kaart.",
  "web.map.empty": "Nog geen locaties om te tonen. Pas je filters aan om meer te zien.",
  "web.map.save": "Bewaren",
  "web.map.saved": "Bewaard",
  "web.map.list": "Lijst",
  "web.favorites.subtitle": "Je opgeslagen champagnehuizen en plekken, klaar voor je volgende trip.",
  "web.activity.subtitle": "Volg proeverijen en bezoeken die de community deelt.",
  "web.activity.loadMore": "Meer laden",
  "web.activity.loadingMore": "Laden…",
  "web.profile.subtitle": "Log in of maak een account aan om je favorieten te synchroniseren.",
  "web.profile.verified": "E-mail geverifieerd",
  "web.profile.unverified": "E-mail niet geverifieerd",
  "web.profile.verify.title": "Verifieer je e-mail",
  "web.profile.verify.body": "Voer de 6-cijferige code in die we naar {{ email }} hebben gestuurd.",
  "web.profile.verify.label": "Verificatiecode",
  "web.profile.verify.placeholder": "6-cijferige code",
  "web.profile.verify.send": "Code opnieuw sturen",
  "web.profile.verify.sending": "Opnieuw aan het sturen…",
  "web.profile.verify.submit": "E-mail verifiëren",
  "web.profile.verify.verifying": "Bezig met verifiëren…",
  "web.profile.verify.validation": "Voer de 6-cijferige code in.",
  "web.profile.verify.sent": "Verificatiecode verstuurd.",
  "web.profile.verify.success": "E-mail geverifieerd. Bedankt!",
  "web.profile.verify.error": "E-mail verifiëren mislukt. Probeer het opnieuw.",
  "web.profile.verify.sendError": "Verificatiecode versturen mislukt. Probeer het opnieuw.",
  "web.profile.session.title": "Sessie",
  "web.profile.session.body": "Log uit om van account te wisselen of je sessie te resetten.",
  "web.profile.loading": "Laden…",
  "web.profile.account.edit": "Bewerken",
  "web.profile.account.close": "Sluiten",
  "web.profile.accountOptions.title": "Accountopties",
  "web.profile.accountOptions.description": "Verwijder je account.",
  "seo.site.name": "Flourish",
  "seo.home.title": "Ontdek Champagne met Flourish",
  "seo.home.description": "Plan je Champagne‑trip met zorgvuldig gekozen routes, iconische huizen en bijzondere stops — allemaal in één gids.",
  "seo.map.title": "Champagne‑kaart en routes",
  "seo.map.description": "Verken champagnehuizen, bezienswaardigheden en toeristische routes op een interactieve kaart om je bezoek te plannen.",
  "seo.houses.title": "Champagnehuizen",
  "seo.houses.description": "Bekijk geverifieerde champagnehuizen op Flourish, ontdek het uitgelichte huis van de dag en verken wijnen, bezoeken en verhalen uit de streek.",
  "seo.getApp.title": "Download de Flourish‑app",
  "seo.getApp.description": "Download Flourish om favorieten te bewaren, de Route Touristique te volgen en je gids altijd bij je te hebben.",
  "seo.experiences.title": "Champagne-ervaringen",
  "seo.experiences.description": "Bekijk geverifieerde Champagne-ervaringen van partnerhuizen en plan je volgende degustatie of bezoek in de streek.",
  "seo.guides.title": "Champagne reisgidsen",
  "seo.guides.description": "Plan champagnehuizen, proeverijen, dorpen, routes en eerste ervaringen met de samengestelde Flourish-gidsen.",
  "seo.favorites.title": "Jouw Champagne‑favorieten",
  "seo.favorites.description": "Bewaar je favoriete champagnehuizen en plekken voor je volgende bezoek.",
  "seo.activity.title": "Proeverijen & bezoeken",
  "seo.activity.description": "Volg proeverijen en bezoeken die door de Flourish‑community zijn gedeeld.",
  "seo.profile.title": "Je Flourish‑profiel",
  "seo.profile.description": "Beheer je account, synchroniseer favorieten en verifieer je e‑mail.",
  "seo.winery.description": "Ontdek {{ name }} in Champagne. Bekijk proefinformatie, contactgegevens en route.",
  "seo.wine.description": "Ontdek {{ wine }} van {{ winery }} en plan je proeverij.",
  "seo.landmark.description": "Ontdek {{ name }} in Champagne en plan je bezoek met Flourish.",
  "tabs.map": "Kaart",
  "tabs.nearby": "In de buurt",
  "tabs.favorites": "Favorieten",
  "tabs.activity": "Activiteit",
  "tabs.profile": "Profiel",
  "activity.title": "Activiteit",
  "activity.loading": "Activiteit laden…",
  "activity.empty.title": "Nog geen activiteit",
  "activity.empty.description": "Proeverijen van jou en je vrienden verschijnen hier.",
  "activity.items.tasting": "Proeverij",
  "activity.items.wineryVisit": "Bezoek champagnehuis",
  "activity.items.landmarkVisit": "Bezoek attractie",
  "activity.errors.load": "Kan activiteit momenteel niet laden.",
  "activity.loginPrompt.title": "Log in om activiteit te zien",
  "activity.loginPrompt.description": "Log in om proeverijen van jou en je vrienden te bekijken.",
  "activity.loginPrompt.button": "Ga naar inloggen",
  "nearby.title": "In de buurt",
  "nearby.loading": "Locaties in de buurt zoeken...",
  "nearby.empty.title": "Nog geen locaties in de buurt",
  "nearby.empty.description": "Schakel locatievoorzieningen in om champagnehuizen en attracties bij jou in de buurt te zien.",
  "nearby.distance": "{{ distance }} km",
  "nearby.locationFallback": "We konden je locatie niet bepalen. Afstanden worden weergegeven vanaf de Champagne-regio.",
  "nearby.errors.load": "Kan locaties in de buurt niet laden.",
  "nearby.filter.title": "Filter op categorie",
  "nearby.filter.all": "Alles",
  "nearby.filter.wineries": "Champagnehuizen",
  "nearby.filter.showFavorites": "Alleen favorieten tonen",
  "nearby.filter.categories": "Categorieën",
  "nearby.filter.filter": "Filter",
  "nearby.sort.label": "Sorteren",
  "nearby.sort.distance": "Afstand",
  "nearby.sort.alpha": "Alfabetisch",
  "nearby.filter.reset": "Resetten",
  "nearby.filter.apply": "Toepassen",
  "map.title": "Kaart",
  "map.marker.youAreHere": "Je bent hier",
  "map.marker.showMore": "Meer tonen",
  "map.marker.openPage": "Open pagina",
  "map.marker.wineryLabel": "Champagnehuizen",
  "map.list.comingSoon.title": "Binnenkort beschikbaar",
  "map.list.comingSoon.body": "We werken aan de champagnehuizen en lanceren deze over een paar weken.",
  "map.marker.routeLabel": "Toeristische route",
  "map.marker.routeDownloadCta": "Download de app om deze route te volgen",
  "map.marker.toggleFavorite": "Favoriet aan/uit",
  "map.detail.loading": "Details laden...",
  "map.detail.error": "Details kunnen niet worden geladen.",
  "map.detail.close": "Sluiten",
  "map.detail.backToMap": "Terug naar de kaart",
  "map.detail.wineryLabel": "Champagnehuis",
  "map.detail.verifiedProfile": "Geverifieerd champagnehuis",
  "map.detail.wineLabel": "Champagne",
  "map.detail.wine.from": "Champagnehuis",
  "map.detail.wine.backToWinery": "Terug naar huis",
  "map.detail.wine.specs": "Technische details",
  "map.detail.wine.dosage": "Dosage",
  "map.detail.wine.assemblage": "Assemblage",
  "map.detail.section.houseHistory": "Geschiedenis",
  "map.detail.section.tastingExperience": "Proeverijervaring",
  "map.detail.section.description": "Beschrijving",
  "map.detail.section.experiences": "Ervaringen",
  "experiences.page.eyebrow": "Geverifieerde ervaringen",
  "houses.page.eyebrow": "Champagnehuizen",
  "houses.page.title": "Ontdek de huizen die je volgende uitstap naar Champagne kunnen bepalen.",
  "houses.page.body": "Blader door een groeiende selectie champagnehuizen op Flourish, van gevestigde namen tot intiemere adressen die een omweg waard zijn.",
  "houses.page.signals.curated.title": "Samengesteld voor ontdekking",
  "houses.page.signals.curated.body": "Elk profiel voelt als een bestemming om te openen, niet als zomaar een vermelding in een directory.",
  "houses.page.signals.verified.title": "Geverifieerde profielen",
  "houses.page.signals.verified.body": "De huizen die je hier ziet zijn openbaar, geverifieerd en klaar om op Flourish ontdekt te worden.",
  "houses.page.signals.planning.title": "Gemaakt om te plannen",
  "houses.page.signals.planning.body": "Ga vlot van inspiratie naar een huispagina, kaartweergave of proefidee zonder het platform te verlaten.",
  "houses.page.featured.eyebrow": "Uitgelicht huis van de dag",
  "houses.page.actions.open": "Openen",
  "houses.page.actions.viewHouse": "Bekijk huis",
  "houses.page.actions.openMap": "Open op kaart",
  "houses.page.filters.search": "Zoeken",
  "houses.page.filters.searchPlaceholder": "Zoek op huisnaam",
  "houses.page.filters.city": "Stad",
  "houses.page.filters.allCities": "Alle steden",
  "houses.page.filters.hasExperiences": "Met ervaringen",
  "houses.page.filters.hasWines": "Met wijnen",
  "houses.page.filters.favorites": "Alleen favorieten",
  "houses.page.filters.sort": "Sorteren",
  "houses.page.filters.clear": "Filters wissen",
  "houses.page.sort.alphabetical": "A tot Z",
  "houses.page.sort.recent": "Recent bijgewerkt",
  "houses.page.collection.eyebrow": "Verder ontdekken",
  "houses.page.collection.title": "Champagnehuizen om verder te verkennen",
  "houses.page.card.fallback": "Open de volledige huispagina om het verhaal, de wijnen en bezoekersinformatie te ontdekken.",
  "houses.page.meta.experience.one": "{{ count }} ervaring",
  "houses.page.meta.experience.other": "{{ count }} ervaringen",
  "houses.page.meta.experience.from.one": "{{ count }} ervaring vanaf {{ price }}",
  "houses.page.meta.experience.from.other": "{{ count }} ervaringen vanaf {{ price }}",
  "houses.page.meta.wine.one": "{{ count }} cuvée",
  "houses.page.meta.wine.other": "{{ count }} cuvées",
  "houses.page.empty.eyebrow": "Geen exacte match",
  "houses.page.empty.title": "Nog geen huizen die bij deze filters passen",
  "houses.page.empty.body": "Wis de filters of spring naar de kaart om Champagne vanuit een andere invalshoek te blijven verkennen.",
  "houses.page.empty.cta": "Verken de kaart",
  "houses.page.footer.eyebrow": "Blijf ontdekken",
  "houses.page.footer.title": "Wissel van perspectief wanneer je wilt.",
  "houses.page.footer.body": "Gebruik de kaart om geografisch te browsen of ga naar ervaringen om je te richten op proeverijen en bezoeken die al beschikbaar zijn.",
  "houses.page.footer.mapCta": "Open de kaart",
  "houses.page.footer.experiencesCta": "Bekijk ervaringen",
  "experiences.page.title": "Boek de meest memorabele ervaringen in Champagne.",
  "experiences.page.body": "Een groeiende selectie degustaties, kelderbezoeken en huisgeorganiseerde momenten van geverifieerde Champagnehuizen, samengebracht op één plek.",
  "experiences.page.stats.experiences": "Ervaringen",
  "experiences.page.stats.houses": "Champagnehuizen",
  "experiences.page.highlights.curated.title": "Zorgvuldig geselecteerd",
  "experiences.page.highlights.curated.body": "Elke ervaring komt van een geverifieerd Champagnehuis dat al op Flourish staat.",
  "experiences.page.highlights.booking.title": "Gemaakt om te plannen",
  "experiences.page.highlights.booking.body": "Bekijk prijs, duur en het huis achter elke ervaring voordat je beslist.",
  "experiences.page.highlights.local.title": "Meer volgt snel",
  "experiences.page.highlights.local.body": "De catalogus is nog jong, dus elke nieuwe ervaring krijgt bewust ruimte om op te vallen.",
  "experiences.page.collection.eyebrow": "Meer om te ontdekken",
  "experiences.page.collection.title": "Ontdek de rest van de collectie",
  "experiences.page.singleNote": "Meer geverifieerde ervaringen verschijnen hier zodra extra Champagnehuizen hun aanbod publiceren.",
  "experiences.page.empty.title": "Ervaringen zijn onderweg",
  "experiences.page.empty.body": "Onze wijnhuizen bereiden hun eerste publieke ervaringen voor. Kom snel terug of verken intussen de Champagnekaart.",
  "experiences.page.empty.cta": "Verken de kaart",
  "map.detail.section.contact": "Contact",
  "map.detail.section.wines": "Signatuurwijnen",
  "map.detail.field.address": "Adres",
  "map.detail.field.email": "E-mail",
  "map.detail.field.website": "Website",
  "map.detail.field.phone": "Telefoon",
  "map.detail.action.openWebsite": "Open",
  "map.detail.action.call": "Bellen",
  "map.detail.action.email": "E-mail",
  "map.detail.action.navigate": "Navigeren",
  "map.detail.action.appleMaps": "Apple Maps",
  "map.detail.action.googleMaps": "Google Maps",
  "map.detail.wines.empty": "Nog geen wijnen beschikbaar.",
  "map.detail.wines.noDescription": "Nog geen beschrijving.",
  "map.detail.experiences.noDescription": "Meer details volgen binnenkort.",
  "map.detail.experiences.checkAvailability": "Beschikbaarheid bekijken",
  "map.detail.experiences.availableNow": "Nu beschikbaar",
  "map.detail.experiences.from": "Vanaf",
  "experience.detail.availability.loading": "Beschikbaarheid laden...",
  "experience.detail.availability.loadError": "Beschikbaarheid kan momenteel niet worden geladen.",
  "experience.detail.duration": "Duur",
  "experience.detail.gallery.open": "Klik om groot te bekijken",
  "experience.detail.gallery.modal": "Afbeeldingengalerij van de ervaring",
  "experience.detail.gallery.close": "Afbeeldingengalerij sluiten",
  "experience.detail.gallery.previous": "Vorige afbeelding",
  "experience.detail.gallery.next": "Volgende afbeelding",
  "experience.detail.gallery.thumbnail": "Open afbeelding {{index}}",
  "experience.detail.gallery.counter": "Afbeelding {{current}} van {{total}}",
  "experience.detail.section.practicalInfo": "Praktische info",
  "experience.detail.section.includedExcluded": "Inbegrepen en uitgesloten",
  "experience.detail.section.location": "Locatie",
  "experience.detail.section.price": "Prijs",
  "experience.detail.practicalInfo.knowBeforeYouGo": "Goed om te weten",
  "experience.detail.practicalInfo.requirements": "Vereisten",
  "experience.detail.practicalInfo.location": "Locatie",
  "experience.detail.includedExcluded.included": "Inbegrepen",
  "experience.detail.includedExcluded.excluded": "Uitgesloten",
  "experience.detail.price.adult": "Volwassene",
  "experience.detail.price.child": "Kind",
  "experience.detail.availability.timeslots": "Beschikbare tijdsloten",
  "experience.detail.availability.noFutureAvailabilityTitle": "Geen beschikbare tijdsloten",
  "experience.detail.availability.book": "Boeken",
  "experience.detail.availability.noSlots": "Selecteer een datum met beschikbaarheid om de tijdsloten te zien.",
  "experience.detail.availability.noFutureAvailability": "Er zijn momenteel geen komende data beschikbaar voor deze ervaring.",
  "experience.detail.availability.unlimited": "Tickets beschikbaar",
  "experience.detail.availability.ticketsLeft": "{{count}} tickets beschikbaar",
  "experience.booking.modal.close": "Boekingsvenster sluiten",
  "experience.booking.step.selection": "Selectie",
  "experience.booking.step.details": "Gegevens",
  "experience.booking.step.payment": "Betaling",
  "experience.booking.step.confirmation": "Bevestiging",
  "experience.booking.stepCounter": "Stap {{current}} van {{total}}",
  "experience.booking.summary.date": "Datum",
  "experience.booking.summary.startHour": "Startuur",
  "experience.booking.summary.endHour": "Einduur",
  "experience.booking.summary.from": "Van",
  "experience.booking.summary.until": "tot",
  "experience.booking.summary.price": "Prijs",
  "experience.booking.summary.guestSingular": "gast",
  "experience.booking.summary.guestPlural": "gasten",
  "experience.booking.selection.title": "Kies je gasten",
  "experience.booking.selection.subtitle": "Selecteer het aantal volwassenen en kinderen voor deze ervaring.",
  "experience.booking.selection.total": "Totale prijs",
  "experience.booking.selection.decreaseAdult": "Aantal volwassenen verlagen",
  "experience.booking.selection.increaseAdult": "Aantal volwassenen verhogen",
  "experience.booking.selection.decreaseChild": "Aantal kinderen verlagen",
  "experience.booking.selection.increaseChild": "Aantal kinderen verhogen",
  "experience.booking.details.title": "Vul je gegevens in",
  "experience.booking.details.subtitle": "Voer de contactgegevens voor deze boeking in.",
  "experience.booking.details.firstName": "Voornaam",
  "experience.booking.details.lastName": "Achternaam",
  "experience.booking.details.email": "E-mailadres",
  "experience.booking.details.phone": "Telefoonnummer",
  "experience.booking.details.error": "Vul alle velden in en voer een geldig e-mailadres in.",
  "experience.booking.payment.title": "Betaling",
  "experience.booking.payment.subtitle": "Betaal veilig om deze boeking af te ronden.",
  "experience.booking.payment.loading": "Beveiligde betaling voorbereiden...",
  "experience.booking.payment.fallback": "Of ga verder met kaart of Bancontact",
  "experience.booking.payment.note": "Afhankelijk van de betaalmethode word je mogelijk kort doorgestuurd om de betaling te autoriseren. Zodra die gelukt is, ronden we de boeking af en sturen we je bevestigingsmail.",
  "experience.booking.payment.error": "We konden je boeking niet afronden. Probeer het opnieuw.",
  "experience.booking.payment.returnError": "We konden je betaling na terugkeer niet bevestigen. Probeer het opnieuw.",
  "experience.booking.confirmation.subtitle": "Bekijk de boekingsbevestiging.",
  "experience.booking.confirmation.title": "Boekingsbevestiging",
  "experience.booking.confirmation.message": "Je boeking is succesvol geplaatst. Je ontvangt binnenkort een bevestigingsmail.",
  "experience.booking.closeConfirm.title": "Boeking sluiten?",
  "experience.booking.closeConfirm.message": "Weet je zeker dat je deze boekingsflow wilt sluiten? Je huidige voortgang gaat verloren.",
  "experience.booking.closeConfirm.confirm": "Boeking sluiten",
  "experience.booking.closeConfirm.cancel": "Boeking voortzetten",
  "experience.booking.actions.back": "Terug",
  "experience.booking.actions.next": "Volgende",
  "experience.booking.actions.confirm": "Boeking bevestigen",
  "experience.booking.actions.pay": "Nu betalen",
  "experience.booking.actions.processing": "Bezig...",
  "experience.booking.actions.close": "Sluiten",
  "map.detail.wines.unshared": "Dit champagnehuis deelt zijn champagnes nog niet met ons.",
  "map.detail.wines.grapes": "druiven",
  "map.legend.title": "Legende",
  "map.legend.landmarksTitle": "Attracties",
  "map.loading.google": "Kaart laden...",
  "map.loading.wineries": "Champagnehuizen laden...",
  "map.loading.places": "Locaties laden...",
  "map.touristicRoutes.title": "Toeristische routes",
  "map.touristicRoutes.names.montagneDeReims": "Montagne de Reims",
  "map.touristicRoutes.names.valleeDeLaMarne": "Marnevallei",
  "map.touristicRoutes.names.coteDesBlancs": "Côte des Blancs",
  "map.touristicRoutes.names.coteauxVitryats": "Coteaux Vitryats",
  "map.touristicRoutes.names.coteauxSezannais": "Sézannais-heuvels",
  "map.touristicRoutes.names.coteDesBar": "Côte des Bar",
  "map.touristicRoutes.background.montagneDeReims": "Een schilderachtige lus door beboste heuvels en iconische Champagnedorpen in de Montagne de Reims.",
  "map.touristicRoutes.background.valleeDeLaMarne": "Volg de Marnevallei, waar wijngaarden langs de rivier liggen en charmante stadjes de route markeren.",
  "map.touristicRoutes.background.coteDesBlancs": "Ontdek de kalkrijke hellingen van de Côte des Blancs, het hartland van Chardonnay in Champagne.",
  "map.touristicRoutes.background.coteauxVitryats": "Een rustiger traject rond de Coteaux Vitryats, met open landschappen en een meer onontdekt gevoel.",
  "map.touristicRoutes.background.coteauxSezannais": "Verken de glooiende Sézannais-heuvels, een mozaïek van wijngaarden en dorpjes.",
  "map.touristicRoutes.background.coteDesBar": "Ga zuidwaarts naar de Côte des Bar, bekend om zijn Pinot Noir-wijngaarden en uitgestrekte landelijke landschappen.",
  "map.errors.googleLoad": "Kan de kaart momenteel niet laden. Probeer het later opnieuw.",
  "map.errors.wineries": "We konden de lijst met champagnehuizen niet laden.",
  "map.errors.landmarks": "We konden de lijst met attracties niet laden.",
  "map.errors.routes": "Kan toeristische routes niet laden.",
  "map.controls.location": "Centreren op mijn locatie",
  "favorites.errors.loginRequired": "Log in om favorieten te beheren.",
  "favorites.errors.update": "Kan favorieten momenteel niet bijwerken.",
  "favorites.title": "Favorieten",
  "favorites.empty.title": "Nog geen favorieten",
  "favorites.empty.description": "Tik op het hartje bij een champagnehuis of attractie om het hier te bewaren.",
  "favorites.empty.wineriesTitle": "Nog geen champagnehuizen",
  "favorites.empty.wineriesDescription": "Ontdek de kaart en tik op het hartje om een champagnehuis op te slaan.",
  "favorites.empty.landmarksTitle": "Geen attracties opgeslagen",
  "favorites.empty.landmarksDescription": "Voeg attracties toe aan je favorieten om ze sneller terug te vinden.",
  "favorites.loginPrompt.title": "Log in om favorieten op te slaan",
  "favorites.loginPrompt.description": "Maak een account aan om je favoriete champagnehuizen bij te houden.",
  "favorites.loginPrompt.button": "Ga naar inloggen",
  "favorites.list.add": "Toevoegen aan favorieten",
  "favorites.list.marked": "Gemarkeerd als favoriet",
  "favorites.list.remove": "Favoriet verwijderen",
  "favorites.confirmRemove": "Deze favoriet verwijderen?",
  "favorites.confirmRemoveConfirm": "Verwijderen",
  "favorites.confirmRemoveCancel": "Annuleren",
  "favorites.segment.all": "Alles",
  "favorites.segment.wineries": "Champagnehuizen",
  "favorites.segment.wineriesShort": "Huizen",
  "favorites.segment.landmarks": "Attracties",
  "favorites.tabs.all": "Alles",
  "favorites.tabs.landmarks": "Attracties",
  "favorites.errors.refresh": "Kan favorieten niet verversen.",
  "profile.title": "Profiel",
  "profile.logout": "Uitloggen",
  "profile.favorites.button": "Favorieten bekijken",
  "profile.login.title": "Inloggen",
  "profile.login.labels.email": "E-mail",
  "profile.login.labels.password": "Wachtwoord",
  "profile.login.placeholders.email": "jij@voorbeeld.com",
  "profile.login.placeholders.password": "Voer je wachtwoord in",
  "profile.login.validation.email": "Voer een geldig e-mailadres in.",
  "profile.login.validation.password": "Wachtwoord is verplicht.",
  "profile.login.submit": "Inloggen",
  "profile.login.switch": "Nog geen account? Registreren",
  "profile.login.error": "Kan niet inloggen. Controleer je gegevens.",
  "profile.register.title": "Registreren",
  "profile.register.labels.name": "Gebruikersnaam",
  "profile.register.labels.email": "E-mail",
  "profile.register.labels.password": "Wachtwoord",
  "profile.register.labels.confirmPassword": "Bevestig wachtwoord",
  "profile.register.placeholders.name": "Je gebruikersnaam",
  "profile.register.placeholders.email": "jij@voorbeeld.com",
  "profile.register.placeholders.password": "Maak een wachtwoord",
  "profile.register.placeholders.confirmPassword": "Wachtwoord opnieuw invoeren",
  "profile.register.validation.name": "Voer een gebruikersnaam in (min. 2 tekens, geen spaties).",
  "profile.register.validation.email": "Voer een geldig e-mailadres in.",
  "profile.register.validation.password": "Wachtwoord moet minstens 8 tekens lang zijn.",
  "profile.register.validation.confirmPassword": "Wachtwoorden moeten overeenkomen.",
  "profile.register.submit": "Account aanmaken",
  "profile.register.switch": "Heb je al een account? Inloggen",
  "profile.register.error": "Registreren mislukt. Probeer het later opnieuw.",
  "profile.register.error.usernameTaken": "Deze gebruikersnaam is al bezet.",
  "profile.register.error.emailTaken": "Er bestaat al een account met dit e-mailadres.",
  "profile.account.settings.title": "Account",
  "profile.account.settings.description": "Beheer je profielgegevens en privacy.",
  "profile.account.settings.username": "Gebruikersnaam",
  "profile.account.settings.usernameDescription": "Werk je gebruikersnaam bij.",
  "profile.account.settings.avatar": "Profielfoto",
  "profile.account.settings.avatarDescription": "Upload of wijzig de foto die op je profiel staat.",
  "profile.account.settings.email": "E-mailadres",
  "profile.account.settings.emailDescription": "Wijzig je inlog e-mail en beheer verificatie.",
  "profile.account.settings.password": "Wachtwoord",
  "profile.account.settings.passwordDescription": "Wijzig het wachtwoord dat je gebruikt om in te loggen.",
  "profile.account.settings.dangerZone": "Gevarenzone",
  "profile.account.settings.deletionDescription": "Vraag om je account permanent te verwijderen.",
  "profile.account.avatar.headline": "Stel je profielfoto in",
  "profile.account.avatar.description": "Upload een foto om je account te personaliseren.",
  "profile.account.avatar.hint": "Gebruik een duidelijke vierkante afbeelding (max. 8 MB).",
  "profile.account.avatar.select": "Kies een afbeelding",
  "profile.account.avatar.remove": "Profielfoto verwijderen",
  "profile.account.avatar.noFile": "Selecteer een afbeelding voordat je doorgaat.",
  "profile.account.avatar.invalidType": "Kies een afbeeldingsbestand.",
  "profile.account.avatar.fileTooLarge": "Afbeelding is te groot (max. 8 MB).",
  "profile.account.avatar.uploadFailed": "We konden deze afbeelding niet uploaden. Probeer een ander bestand.",
  "profile.account.avatar.success": "Profielfoto succesvol bijgewerkt.",
  "profile.account.avatar.removed": "Profielfoto verwijderd.",
  "profile.account.avatar.error": "Profielfoto kan momenteel niet worden bijgewerkt.",
  "profile.account.labels.name": "Gebruikersnaam",
  "profile.account.labels.email": "E-mail",
  "profile.account.placeholders.name": "Je gebruikersnaam",
  "profile.account.placeholders.email": "jij@voorbeeld.com",
  "profile.account.validation.name": "Voer een gebruikersnaam in (min. 2 tekens, geen spaties).",
  "profile.account.validation.email": "Voer een geldig e-mailadres in.",
  "profile.account.submit": "Wijzigingen opslaan",
  "profile.account.success": "Account succesvol bijgewerkt.",
  "profile.account.error": "Account kan momenteel niet worden bijgewerkt.",
  "profile.accountDeletion.cardTitle": "Mijn account verwijderen",
  "profile.accountDeletion.description": "Vraag verwijdering van je account en gegevens aan. Je bevestigt met je wachtwoord en een 6-cijferige e-mailcode.",
  "profile.accountDeletion.passwordPlaceholder": "Huidig wachtwoord",
  "profile.accountDeletion.passwordRequired": "Voer je wachtwoord in om te bevestigen.",
  "profile.accountDeletion.requestCodeButton": "Code sturen",
  "profile.accountDeletion.codeTitle": "Bevestigingscode invoeren",
  "profile.accountDeletion.codePlaceholder": "123456",
  "profile.accountDeletion.codeRequired": "Voer de 6-cijferige code uit je e-mail in.",
  "profile.accountDeletion.codeSent": "Er is een bevestigingscode naar je e-mail gestuurd.",
  "profile.accountDeletion.codeError": "De bevestigingscode kan momenteel niet worden verstuurd.",
  "profile.accountDeletion.confirmButton": "Account verwijderen",
  "profile.accountDeletion.cancel": "Mijn account behouden",
  "profile.accountDeletion.success": "Je account is verwijderd. Jammer dat je weggaat.",
  "profile.accountDeletion.error": "Account verwijderen is momenteel niet mogelijk.",
  "profile.password.labels.current": "Huidig wachtwoord",
  "profile.password.labels.new": "Nieuw wachtwoord",
  "profile.password.labels.confirm": "Bevestig nieuw wachtwoord",
  "profile.password.placeholders.current": "Voer huidig wachtwoord in",
  "profile.password.placeholders.new": "Voer nieuw wachtwoord in",
  "profile.password.placeholders.confirm": "Voer nieuw wachtwoord opnieuw in",
  "profile.password.validation.current": "Voer je huidige wachtwoord in.",
  "profile.password.validation.length": "Wachtwoord moet minimaal 8 tekens bevatten.",
  "profile.password.validation.confirm": "Bevestig je nieuwe wachtwoord.",
  "profile.password.error.mismatch": "Nieuwe wachtwoorden komen niet overeen.",
  "profile.password.error.generic": "Wachtwoord kan momenteel niet worden bijgewerkt.",
  "profile.password.success": "Wachtwoord succesvol bijgewerkt.",
  "profile.password.submit": "Wachtwoord bijwerken",
  "profile.usernameAvailability.checking": "Beschikbaarheid van gebruikersnaam controleren...",
  "profile.usernameAvailability.available": "Gebruikersnaam is beschikbaar.",
  "profile.usernameAvailability.unavailable": "Gebruikersnaam is niet beschikbaar.",
  "profile.usernameAvailability.error": "Kan gebruikersnaam momenteel niet controleren.",
  "landmarks.categories.museum": "Museum",
  "landmarks.categories.historical": "Historische locatie",
  "landmarks.categories.viewpoint": "Uitzichtpunt",
  "landmarks.categories.attraction": "Attractie"
}
